<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    destroy-on-close
    :show-close="false"
    width="400px"
    custom-class="bindAccount__dialog onboarding__dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="bindAccount__dialog__container">
      <div>
        <p>该账号已被绑定</p>
        <p>请更换其他账号进行绑定，或注册新账号</p>
      </div>
      <div class="bindAccount__dialog__container__btn">
        <div @click="clickBindAccount">绑定其他账号</div>
        <div @click="clickRegister">注册新账号</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'BindOtherAccountDialog',
  computed: {
    visible() {
      return this.$store.getters['wxLogin/showBindOtherAccountDialog']
    },
  },
  methods: {
    clickRegister() {
      this.$store.dispatch('wxLogin/updateBindOtherAccountDialog', false)
      this.$router.push({
        name: 'register',
      })
    },
    clickBindAccount() {
      this.$store.dispatch('wxLogin/updateBindOtherAccountDialog', false)
    },
  },
}
</script>
<style lang="scss">
div.bindAccount__dialog {
  border-radius: 12px !important;
  &__header {
    color: rgba(0, 0, 0, 0.8);
    .close {
      position: absolute;
      top: -18px;
      right: -18px;
      cursor: pointer;

      .svg-icon {
        width: 36px !important;
        height: 36px !important;
        color: unset !important;
      }
    }
  }
  &__container {
    text-align: center;
    //padding: 30px;
    p {
      font-size: 16px;
      font-weight: 600;
      color: #454545;
      margin-top: 10px;
    }
    &__btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      div {
        background: var(--bgGreen);
        border-radius: 6px;
        font-size: 14px;
        border: 1px solid var(--loginBtnBorder);
        cursor: pointer;
        color: var(--memberPlanColor);
      }
    }
  }
}
</style>
